import common from '@/scripts/common';

export default {
    getMismatchedCategories: function (variables, categories) {
      return getMismatchedCategories(variables, categories);
    }
}

function getMismatchedCategories(variables, categories) {
  let cat = categories; //.filter(c => c.var === 'R_ASTHNOW');
  let categories2 = getFirstLevels(cat, true).concat(getFirstLevels(cat, false));
  var mismatch1 = getRawCategories(variables, categories2);
  var mismatch1Display = mismatch1.doesntMatch.map(v => ToDoesntMatchDisplay(categories2, v));
  var missing1Display = mismatch1.yearsMissing.map(v => ToMissingDisplay(categories2, v));
  var allMismatched = mismatch1Display.concat(missing1Display);
  var models = allMismatched.map(m => toModel(m));
  let byVariableAndLevel = common.groupBy(models, 'key');
  var reduced = byVariableAndLevel.map(g => reduceByMatchingVariables(g));
  var results = [];
  reduced.forEach(r1 =>
    r1.forEach(r2 => results.push(r2)));
  results = results.sort(function(a, b) { return (a.variable + a.levelNumber) - (b.variable + b.levelNumber); });
  console.log(results);
  return results;
}

function reduceByMatchingVariables(variableList) {
  variableList.forEach(v => v.combinedLabels = v.label1 + v.label2);
  var byVariable1 = common.groupBy(variableList, 'combinedLabels');
  var results = byVariable1.map(v => combineMatchingYears(v));
  return results;
}


function combineMatchingYears(list) {
  return {
    variable: list[0].variable,
    levelNumber: list[0].levelNumber,
    firstYears: [...new Set(list.map(l => l.year1))].join(', '),
    secondYears: [...new Set(list.map(l => l.year2))].join(', '),
    label1: list[0].label1,
    label2: list[0].label2
  }
}

function compressLabel(row, i) {
  if (row.length <= i)
    return "";
  if (!row[i] || row[i] === '[No Level]')
    return "";
  return compress(row[i]);
}

function toModel(row) {
  let l = row.length;
  let results = {
    variable: l > 0 ? row[0] : "",
    levelNumber: l > 1 ? row[1] : "",
    year1: l > 1 ? row[2] : "",
    label1: l > 1 ? row[3] : "",
    label1Compressed: compressLabel(row, 3),
    year2: l > 1 ? row[4] : "",
    label2: l > 1 ? (row[5]) : null,
    label2Compressed: compressLabel(row, 5)
  };
  results.key = results.variable + '|' + results.levelNumber;
  return results;
}

function compress(label) {
  return label.toLowerCase().replace(/[^\w\d]/g, '');
}

function getRawCategories(variables, categories2, oldYears) {
  var mismatched = [];
  var dictionary = {};
  var allKeys = [];
  let categories = oldYears !== undefined && oldYears !== null ? filterCategoriesByYearRange(categories2, oldYears) : categories2;
  categories.forEach(c => c.levelLabelCompressed = compress(c.title));
  var mismatched2 = categories.map(c1 =>
    categories.filter(c2 => c1.var === c2.var && c1.year < c2.year)
      .map(c2 => {
        var key = buildCategoryKey(c1);

        if (!dictionary[key]) {
          allKeys.push(key);
          var years = getAllYearsForVariable(variables, c1.var, oldYears);
          dictionary[key] = createValidationProperties(c1, years);
        }
        dictionary[key].exists[c1.year] = true;
        dictionary[key].exists[c2.year] = true;

        if (c1.var === c2.var &&
          c1.id === c2.id) {
          var year2 = c2.year;
          var matches = categoriesMatch(c1, c2);
          dictionary[key].matches[c1.year + '-' + year2] = matches;
          if (!categoriesMatch(c1, c2))
            mismatched.push({ c1: c1, c2: categories[2] });
        }

      }));
  var results = scanCategoriesDictionary(dictionary, allKeys, oldYears);
  return results;
}

function createValidationProperties(c1, years) {
  if (years.length === 0)
    console.log('Category has no variable objects', c1)
  return {
    matches: {},
    //Object.assign(...years.map(y => ({[c1.year + '-' + y]: false}))),
    years: years,
    exists: years.length === 0 ? {} : Object.assign(...years.map(y => ({ [y]: false }))),
    variable: c1.var
  };
}

function ToDoesntMatchDisplay(categories, m) {
  var a = m.split('-');
  var level = parseInt(a[1], 10);
  //var year = parseInt(a[2], 10);
  var variable = a[0];
  //a.push(getCategory(categories, parseInt(a[2], 10), variable, level));
  //a.push(getCategory(categories, parseInt(a[3], 10), variable, level));
  return [a[0], a[1], a[2], getCategory(categories, parseInt(a[2], 10), variable, level), a[3], getCategory(categories, parseInt(a[3], 10), variable, level)];
}

function ToMissingDisplay(categories, m) {
  var a = m.split('-');
  var level = parseInt(a[1], 10);
  //var year = parseInt(a[2], 10);
  var variable = a[0];
  return [a[0], a[1], a[2], getCategory(categories, parseInt(a[2], 10), variable, level), null, null];
  //a.push(null);  //no Year 2
  //a.push(getCategory(categories, parseInt(a[2], 10), variable, level));
  //a.push(null); //No Year 2
  //a.push(getCategory(parseInt(a[3], 10), variable, level));
  //return a;
}

function categoriesMatch(c1, c2) {
  var matches = c1.levelLabelCompressed === c2.levelLabelCompressed &&
    c1.levelNonResponse === c2.levelNonResponse;
  // if (!matches)
  //     console.log('Doesnt match', c1, c2)
  return matches;
}

function buildCategoryKey(c1) {
  return c1.var + '-' + c1.id;
}

function scanCategoriesDictionary(dictionary, allKeys, oldYears) {
  var yearsMissing = [];
  var doesntMatch = [];
  var updatedDictionary = {};

  for (var i = 0; i < allKeys.length; ++i) {
    var key = allKeys[i];
    var item = dictionary[key];
    var years = item.years.sort((a, b) => a - b);
    item.yearsMissing = [];
    item.doesntMatch = [];
    var mismatched2 = years.map(year1 => {
      //var variableExistsForYear = dictionary[item.variable + '-1'].exists[year1];
      if (!item.exists[year1]) {
        // console.log('item doesnt exist', item, year1);
        item.yearsMissing.push(year1);
        yearsMissing.push(key + '-' + year1);
        updatedDictionary[key] = item;
      }
      years.filter(year2 => year1 < year2).map(year2 => {
        var key2 = year1 + '-' + year2;
        if (item.exists[year1] && item.exists[year2] && !item.matches[key2]) {
          item.doesntMatch.push(key2);
          doesntMatch.push(key + '-' + key2);
          updatedDictionary[key] = item;
        }
      });
    });
  }

  // console.log('scanCategoriesDictionary', (oldYears ? 'old' : 'new'), updatedDictionary, 'yearsMissing', yearsMissing, 'doesntMatch', doesntMatch);
  return { dictionary: updatedDictionary, yearsMissing, doesntMatch };
}


function getFirstLevels(categories, oldYears) {
  let levels1 = filterCategoriesByYearRange(categories, oldYears);
  levels1.map(l => l.groupKey = l.var + '_' + l.id);
  var results = common.groupBy(levels1, 'groupKey').map(r => r[0]);
  //console.log('results', levels1, results);
  return results;
}
function getAllYearsForVariable(variables, name, oldYears) {
  if (oldYears === undefined || oldYears === null)
    return variables.filter(v => v.variable === name).map(v => v.year);
  if (oldYears)
    return variables.filter(v => v.variable === name && v.year < 2011).map(v => v.year);
  else
    return variables.filter(v => v.variable === name && v.year > 2010).map(v => v.year);
}

function filterCategoriesByYearRange(categories, oldYears) {
  if (oldYears)
    return categories.filter(c => c.year < 2011);
  else
    return categories.filter(c => c.year > 2010);
}

function getCategory(categories, year, variable, level) {
  var category = '';
  try {
    category = categories.filter(e => e.year === year && e.var === variable)[level - 1].title;
  } catch (e) {
    category = '[No Level]';
  }
  return category;
}









// function getMismatchedCategoriesByMethodology (variables, categories) {
//   var mismatch1 = getRawCategories(variables, categories, true);
//   var mismatch1Display = mismatch1.doesntMatch.map(v => ToDoesntMatchDisplay(categories, v));
//   var mismatch2 = getRawCategories(variables, categories, false);
//   var mismatch2Display = mismatch2.doesntMatch.map(v => ToDoesntMatchDisplay(categories, v));
//   var missing1Display = mismatch1.yearsMissing.map(v => ToMissingDisplay(categories, v));
//   var missing2Display = mismatch2.yearsMissing.map(v => ToMissingDisplay(categories, v));
//   return mismatch1Display.concat(mismatch2Display).concat(missing1Display).concat(missing2Display);
// }

// function variablesMatch1(v1, v2) {
//   return v1.groupTitle === v2.groupTitle &&
//     v1.group === v2.group &&
//     v1.variableTitle === v2.variableTitle &&
//     v1.isRow === v2.isRow &&
//     v1.isColumn === v2.isColumn &&
//     v1.isDependent === v2.isDependent &&
//     v1.isIndependent === v2.isIndependent &&
//     v1.isControl === v2.isControl &&
//     v1.isCategorical === v2.isCategorical;
// }
// function formatMatch(v1, v2, column) {
//   return column + ': [' + v1[column] + '] === [' + v2[column] + ']';
// }

// function formatCategoryMatch(c1, c2, column) {
//   return column + ': [' + c1[column] + '] === [' + c2[column] + ']';
// }
// function getCategoryMismatch(c1, c2) {
//   var misMatches = matchColumns.map(c => c1[c] === c2[c] ? null : formatCategoryMismatch(c1, c2, c)).filter(r => r !== null);
//   if (misMatches.length === 0)
//     return null;
//   misMatches.unshift(formatCategoryMismatch(c1, c2, 'year'));
//   //console.log(c1, c2, misMatches);
//   return 'variable: ' + c1.variable + ' ' + misMatches.join(', ')
// }

// function formatCategoryMismatch(c1, c2, column) {
//   return column + ': [' + c1[column] + '] !== [' + c2[column] + ']';
// }
